export enum eFeatures {
  None = 0,
  RelevantTopics = 1,
  OnlineTutorials = 2,
  GettingStartedChecklist = 3,
  SubmitSupportTicket = 4,
  ReferralRewards = 5,
  NewCompany = 6,
  MyCompanies = 7,
  BulkCompanyActions = 8,
  NewContact = 9,
  ViewMyContacts = 10,
  ExcelUploadWizard = 11,
  BulkContactActions = 12,
  CreateContactMap = 13,
  RestoreContacts = 14,
  ManageDuplicates = 15,
  NewLead = 16,
  MyActiveLeads = 17,
  MyLeads = 18,
  BulkLeadActions = 19,
  ViewMailings = 20,
  CreateNewMailing = 21,
  ViewEmailBlastMaiings = 22,
  CreateNewEmailBlastMailing = 23,
  ViewTextBlastMailings = 24,
  CreateNewTextBlastMailing = 25,
  KeywordList = 26,
  AutomationProcesses = 27,
  CustomActionScreens = 29,
  WebForms = 30,
  EmailTemplates = 31,
  MailMergeTemplates = 33,
  TextMessageTemplates = 34,
  ImageBank = 35,
  ClickTrackings = 36,
  VoiceRecordings = 37,
  SlidecastPresentations = 38,
  AppointmentTypeSummary = 39,
  AppointmentbyTwoDimensions = 40,
  CoachCorner = 41,
  QualificationCallReport = 42,
  NoteTypeSummary = 43,
  CallActionButtonClickReport = 44,
  TextMessageLog = 45,
  EmailOpenRateReport = 46,
  SAMVoiceCallReport = 47,
  SlidecastAnalytics = 48,
  SkypeCallLog = 49,
  DistributionbyTwoDimesions = 50,
  DistribtionByManager = 51,
  DistributionbyClassification = 52,
  DistributionbyTwoDimension = 54,
  ReferralReport = 55,
  TagCloud = 56,
  ClickTracking = 57,
  BuzzScore = 58,
  ProjectedRevenuebyManager = 60,
  ProjectedRevenuebyClassification = 61,
  ProjectedRevenuebyMonth = 62,
  DistributionbyTwoDimensions = 63,
  FilterReport = 64,
  InvoiceReport = 65,
  AccountSetup = 66,
  UserSetup = 67,
  SecuritySettings = 68,
  CompanyModuleSettings = 69,
  ContactModuleSettings = 70,
  LeadModuleSettings = 71,
  AppointmentNoteMailingsettings = 72,
  TagSettings = 73,
  TextMessageSettings = 74,
  VoiceSettings = 75,
  EngageSecurity = 76,
  EngageBillingManager = 77,
  EngageServicesContract = 78,
  EngageAnnouncements = 79,
  EngageFreeTrials = 80,
  EngageServiceStatus = 81,
  EngageAccountSetup = 82,
  RoleSetup = 83,
  Configuration = 84,
  TeamOfficeSetup = 85,
  CompanySetup = 86,
  WebFormManager = 87,
  EngageRepSettings = 88,
  MyLinks = 89,
  EmailTemplate = 90,
  VideoBank = 93,
  PatentPlusAdmins = 94,
  PatentPlusReps = 95,
  ManageRoles = 96,
  OfficeSetup = 97,
  PauseLeads = 98,
  ApprovePauseRequest = 99,
  Reporting = 100,
  ConfigurationAdv = 101,
  ContractsAdministrator = 102,
  Contracts = 103,
  ContractsConfiguratio = 104,
  ViewContracts = 105,
  ReceivedContracts = 106,
  ResearchReview = 107,
  ResearchSubmission = 108,
  ResearchPrinters = 109,
  ResearchWriting = 110,
  ContractApproval = 111,
  ResearchTyping = 112,
  ClientServicesReview = 113,
  Portal = 114,
  AllContracts = 115,
  ContractList = 116,
  ContractsConfig = 117,
  Leads = 118
}

export enum eUserPermissions {
  Disabled = 0,
  Active = 1,
  Unknown = 9
}


export enum eCampaignTemplateOwnerType {
  Unknown = 0,
  Personal = 1,
  Contact = 2,
  Lead = 3,
  Proposal = 4,
  Project = 5
}

export enum eCampaignStatus {
    None = 0,
    Active = 1,
    Draft = 2,
    Paused = 3,
    Cancelled = 4,
    Completed = 5
}
export enum eApptCategory {
    Personal = 0,
    Company = 1,
    Contact = 2,
    Lead = 3,
    None = 4,
    Proposal = 5,
    Project = 6,
    CompanyObject = 7
}


export enum eTempMMDocumentType {
  Unknown = 0,
  Personal = 1,
  Contact = 2,
  Lead = 3,
  Proposal = 4,
  Project = 5,
  LinkGroup = 6,
  Note = 7,
  Invoice = 8,
  Mailing = 11,
  EBlast = 12
}

export enum eUserRole {
    None = 0,
    General = 1,
    Manager = 2,
    Administrator = 3,
    SuperUser = 4,
    EngageAdminUser = 5
}

export enum eNoteOwnerType {
    Unknown = 0,
    Personal = 1,
    Contact = 2,
    Lead = 3,
    Company = 4,
    Project = 5,
    LinkGroup = 6,
    Note = 7,
    Invoice = 8,
    Mailing = 11
}
export enum eContactTxtMsgStatus {
    xHardOptOut = 0,
    HardOptIn = 1,
    SoftOptIn = 2,
    UserOptOut = 3
}

export enum eDDField {
    Unknown = 0,
    CoClass1Code = 1,
    CoClass2Code = 2,
    CoClass3Code = 3,
    CoClass4Code = 4,
    CoClass5Code = 5,
    CoClass6Code = 6,
    CoClass7Code = 7,
    CoClass8Code = 8,
    Class1Code = 11,
    Class2Code = 12,
    Class3Code = 13,
    Class4Code = 14,
    Class5Code = 15,
    Class6Code = 16,
    Class7Code = 17,
    Class8Code = 18,
    Multi1Code = 19,
    Multi2Code = 110,
    Multi3Code = 111,
    Multi4Code = 112,
    LeadClass1Code = 20,
    LeadClass2Code = 21,
    LeadClass3Code = 22,
    LeadClass4Code = 23,
    LeadClass5Code = 24,
    LeadClass6Code = 25,
    LeadClass7Code = 26,
    LeadClass8Code = 27,
    LeadClass9Code = 28,
    LeadMulti1Code = 210,
    LeadMulti2Code = 211,
    LeadMulti3Code = 212,
    LeadMulti4Code = 213,
    LeadStatusCode = 214,
    ZapierEventCode = 300,
    TeamCode = 500,
    OfficeCode = 600,
    ApptGeneralTypeCode = 700,
    ApptContactTypeCode = 701,
    ApptLeadTypeCode = 702,
    ApptProposalTypeCode = 703,
    ApptProjectTypeCode = 704,
    NoteTypeCode = 800,
    MailingTypeCode = 900
}

export enum eMobileBlockType {
    Unknown = 0,
    UnBlock = 1,
    Block = 2,
}

export enum eMobileOptType {
    Unknown = 0,
    OptIn = 1,
    OptOutByContact = 2,
    OptOutByUser = 3
}
export enum eSection {
    System = 0,
    Communication = 1,
    Address = 2,
    AddtionalInformation = 3,
    ClassificationDropDown = 4,
    ClassificationCheckBox = 5,
    Comments = 6,
    ImportantDates = 7,
    MoreFields = 8,
    General = 9
}
export enum eTxtMsgSettingsStatus {
    None = 0,
    Active = 1,
    Waiting_To_Be_Configured = 2
}
